import { Payment } from "./Payment";

class Order {
  constructor() {
    this.$products = [];
    this.$student = null;
    this.$coupon = null;
    this.$customerSource = null;
    this.$total = 0;
    this.financial_summary = null;
    this.$payments = [new Payment()];
    this.$lineItems = [];
    this.$paid = false;
    this.$notes = null;
    this.$id = undefined;
    this.$created_at = undefined;

    // @deprecated
    this.submitted = false;

    // if (this.student !== null && !this.student.guardian) {
    //     this.payments.map((payment) => {
    //         payment.creditCard().setName(this.student.fullname());
    //         return payment;
    //     });
    // }
  }

  /**
   * @returns {number}
   */
  id() {
    return this.$id;
  }

  /**
   * @returns {boolean}
   */
  paid() {
    return this.$paid;
  }

  /**
   * @param {INote[]} notes
   */
  setNotes(notes) {
    this.$notes = notes;
  }

  /**
   * @returns {string}
   */
  createdAt() {
    return this.$created_at;
  }

  /**
   * @param {string} status
   */
  setStatus(status) {
    this.$status = status;
  }

  /**
   * @returns {string}
   */
  status() {
    return this.$status;
  }

  /**
   * @param {boolean} paid
   */
  setPaid(paid = false) {
    this.$paid = paid;
  }

  /**
   * @param {Array<LineItem>} lineItems
   */
  setLineItems(lineItems = []) {
    this.$lineItems = lineItems;
  }

  /**
   * @returns {boolean}
   */
  hasStudent() {
    return this.$student !== null;
  }

  /**
   * @returns {number}
   */
  total() {
    return this.$total;
  }

  /**
   * @returns {Student}
   */
  student() {
    return this.$student;
  }

  /**
   * @returns {Coupon}
   */
  coupon() {
    return this.$coupon;
  }

  /**
   * @returns {Array<Payment>}
   */
  payments() {
    if (!this.$payments) {
      return [];
    }
    return this.$payments;
  }

  /**
   * @return {Array<Product>}
   */
  products() {
    if (!this.$products) {
      return [];
    }
    return this.$products;
  }

  /**
   * @param {Array<Product>} products
   */
  setProducts(products) {
    this.$products = products;
  }

  /**
   * @param {Array<Payment>} payments
   */
  setPayments(payments) {
    this.$payments = payments;
  }

  /**
   * Used (right now only during checkout) to set the coupon being used
   *
   * @param {Coupon} coupon The coupon used on this order.
   */
  setCoupon(coupon) {
    this.$coupon = coupon;
  }

  /**
   * @returns {void}
   */
  removeCoupon() {
    this.$coupon = null;
  }

  /**
   * The customer source associated with this order
   *
   * @param {{id: number, name: string, slug: string}} customerSource
   */
  setCustomerSource(customerSource) {
    this.$customerSource = customerSource;
  }

  /**
   * Sets the student associated with this order. The student is also the customer.
   *
   * @param {Student} student
   */
  setStudent(student) {
    this.$student = student;
  }

  /**
   * Remove the currently attached student. Currently used during check-out if admins select the wrong kid.
   */
  removeStudent() {
    delete this.$student;
  }

  /**
   * @param {number} total
   */
  setTotal(total) {
    this.$total = total;
  }

  /**
   * @returns {Array<LineItem>}
   */
  lineItems() {
    return this.$lineItems;
  }

  /**
   * @returns {string}
   */
  notes() {
    return this.$notes;
  }

  /**
   * The customer source associated with this order
   *
   * @returns {{id: number, name: string, slug: string} | null}
   */
  customerSource() {
    return this.$customerSource;
  }
}

export { Order };
